var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0686 11.1361V4.36187L6.2013 0.974121L0.333984 4.36187V11.1361L6.2013 14.5238L12.0686 11.1361Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinder);
export default __webpack_public_path__ + "static/media/binder.33f65b52d7541121e9bb5566ba2d34b3.svg";
export { ForwardRef as ReactComponent };